export default __webpack_public_path__ + "static/media/menuL_icon_03.6ae54441.png";